import React from 'react'
import PropTypes from 'prop-types'
import { TourneeTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const Tournee = ({
  fetchData,
  success,
  pageLimitChanged,
  pageChanged,
  onCloseReset,
  isLoadingfetchTournees,
  tourneesList,
  tourneesListCount,
  searchData,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={TourneeTableHead}
      //Commonfields
      globalID={'Tournee'}
      searchPlaceholder={'Rechercher par Tournée'}
      title={'Tournées'}
      fetchData={fetchData}
      loadingData={isLoadingfetchTournees}
      dataList={tourneesList}
      countData={tourneesListCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isTournee={true}
    />
  )
}
Tournee.propTypes = {
  fetchData: PropTypes.func,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  tourneesListCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
  isLoadingfetchTournees: PropTypes.bool,
  tourneesList: PropTypes.array,
}
export default Tournee
